import { render, staticRenderFns } from "./communicationDashboardSignatureGenerator.vue?vue&type=template&id=a7d1ff08&scoped=true"
import script from "./communicationDashboardSignatureGenerator.vue?vue&type=script&lang=js"
export * from "./communicationDashboardSignatureGenerator.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardSignatureGenerator.vue?vue&type=style&index=0&id=a7d1ff08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d1ff08",
  null
  
)

export default component.exports